"use client"

import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import api from "../utils/api"
import Cookies from "js-cookie"
import { loadFromLocalStorage, saveToLocalStorage } from "../redux/helpers/localStorage"
import { setRestaurantId } from "../redux/restaurantSlice"

import FinalDesktopImage from "../assets/final.jpg"
import FinalMobileImage from "../assets/finalM.jpg"
import Footer from "../component/layout/Footer"

export default function LandingPageHome() {
  const [restaurants, setRestaurants] = useState([])
  const dispatch = useDispatch()

  function saveRestaurantStatusToLocalStorage(restaurantId, isOpen, holidays) {
    let restaurantStatus = isOpen ? "open" : "closed"
    if (holidays?.length > 0) {
      const today = new Date().toISOString().split("T")[0]
      const holidayToday = holidays.some((holiday) => new Date(holiday.date).toISOString().split("T")[0] === today)
      if (holidayToday) restaurantStatus = "closed"
    }
    localStorage.setItem(`restaurantStatus_${restaurantId}`, restaurantStatus)
    Cookies.set(`restaurantStatus_${restaurantId}`, restaurantStatus)
  }

  const fetchRestaurantData = async () => {
    try {
      const response = await api.get("/restaurant")
      const fetchedRestaurants = response.data.results
      setRestaurants(fetchedRestaurants)

      fetchedRestaurants.forEach((restaurant) => {
        saveRestaurantStatusToLocalStorage(restaurant._id, restaurant.isActive, restaurant?.holidays)
      })

      const savedRestaurantId = loadFromLocalStorage("selectedRestaurantId")
      if (savedRestaurantId) {
        dispatch(setRestaurantId(savedRestaurantId))
      }
    } catch (error) {
      console.error("Error fetching restaurant data:", error)
    }
  }

  useEffect(() => {
    fetchRestaurantData()
  }, [])

  const handleSelect = (restaurant) => {
    dispatch(setRestaurantId(restaurant._id))
    saveToLocalStorage("selectedRestaurantId", restaurant._id)
    Cookies.set("selectedRestaurantName", restaurant.title)
    Cookies.set("selectedSlug", restaurant.slug)

    // full reload
    window.location.href = `/${restaurant.slug}`
  }

  return (
    <>
      <div className="relative w-full min-h-screen">
        {/* Background for desktop */}
        <div
          className="absolute inset-0 bg-cover bg-center hidden md:block"
          style={{ backgroundImage: `url(${FinalDesktopImage})` }}
        />
        {/* Background for mobile */}
        <div
          className="absolute inset-0 bg-cover bg-center md:hidden"
          style={{ backgroundImage: `url(${FinalMobileImage})` }}
        />

        {/* Headline over hero */}
        <div className="absolute top-6 md:top-10 left-1/2 -translate-x-1/2 z-20 px-4">
          <h1 className="text-center text-pretty text-2xl md:text-5xl font-semibld text-white bg-black/20 rounded-xl px-4 py-2 shadow-xl body">
            {"Your order — your way "}
            <span className="font-semibld">Pick up</span>
            {" or "}
            <span className="font-semibld">Delivery.</span>
          </h1>
        </div>
        {/* Improve logo layout and sizing */}
       {/* Logo Section with Heading */}
<div className="absolute inset-x-0 md:bottom-8 bottom-36 z-10">
  <div className="mx-auto max-w-3xl px-4 flex flex-col items-center">
    
    {/* Heading above logos */}
    <p className="text-white text-lg md:text-2xl font-semibold mb-4 bg-black/60 px-4 py-2 rounded-xl shadow-lg body">
      Please choose your favorite
    </p>
    
    {/* Logos */}
    <div className="inline-flex flex-wrap items-center justify-center gap-4 bg-white/30 backdrop-blur-md p-5 md:p-4 rounded-2xl shadow-xl">
      {restaurants.map((restaurant) => (
        <div
          key={restaurant._id}
          onClick={() => handleSelect(restaurant)}
          className="w-24 h-24 md:w-28 md:h-28 bg-white rounded-2xl shadow-lg cursor-pointer flex items-center justify-center hover:scale-110 transition-transform"
        >
          <img
            src={restaurant.logo || "/placeholder.svg"}
            alt={restaurant.title}
            className="max-w-20 max-h-20 md:max-h-24 md:max-w-24 object-contain"
          />
        </div>
      ))}
    </div>
  </div>
</div>

      </div>
      <Footer />
    </>
  )
}
